<template>
  <vue3-video-player
    :src="src"
    title=""
    :controls="false"
    :cover="cover"
    :loop="true"
    autoplay
  ></vue3-video-player>
</template>

<script>
export default {
  name: 'VideoGeneric',

  props: {
    src: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: false,
      default: 'generic_video',
    },
    cover: {
      type: String,
      required: false,
      default: '',
    },
    other: {
      type: String,
      required: false,
      default: 'false',
    },
  },
}
</script>
